module.exports = __webpack_public_path__ + "static/media/city6.ad1210b7.jpg";